import {
  GET_DASHBOARD_QUEUE_TASKS,
  GET_DASHBOARD_QUEUE_TASKS_SUCCESS,
  GET_DASHBOARD_QUEUE_TASKS_ERROR,
} from './actionTypes';

// P01021-139: tarjeta "Cola" del Dashboard — paginada y filtrada por servidor
// (status = En cola + En cola reserva), en vez de traer toda tasklist.
export const getDashboardQueueTasks = (user, size, page) => {
  return {
    type: GET_DASHBOARD_QUEUE_TASKS,
    payload: { user, size, page },
  };
};

export const getDashboardQueueTasksSuccess = (tasks, message) => {
  return {
    type: GET_DASHBOARD_QUEUE_TASKS_SUCCESS,
    payload: { tasks, message },
  };
};

export const getDashboardQueueTasksError = (msg) => {
  return {
    type: GET_DASHBOARD_QUEUE_TASKS_ERROR,
    payload: msg,
  };
};
